
<mat-spinner *ngIf="loading"></mat-spinner>

<div class="card mb-3" style="max-width: 540px;"  *ngIf="listActivitys.length == 0">
  <div class="row no-gutters p-4">
    <h5>Add you first activity and start the adventure !</h5>
  </div>
</div>



<div *ngFor='let activity of listActivitys'>


  <div class="card mb-3" style="max-width: 540px;"  *ngIf="!loading">
    <div class="row no-gutters">
      <!-- IMAGE -->
      <!-- <div class="col-md-1 my-auto text-center pl-3">
        <fa-icon [icon]="faRunning" class="fa-2x" style="color: #000;"></fa-icon>
      </div> -->
      <!-- BLOC INFO -->
      <div class="col-md-12">
        <div class="card-body">
          <div class="row">
            <!-- TITRE -->
            <div class="col-md-12 m-1">
              <h6>{{ activity.title }}</h6> 
              <a mat-button  *ngIf="activity.idRunStrava" target="_blank" href="https://www.strava.com/activities/{{activity.idRunStrava}}">See activity on Strava</a>
            </div>
          </div>
          <div class="row">
            <!-- NEW TEST -->  
            <!-- DISTANCE -->
            <div class="col-md-4">
              <p class="card-text">
                <fa-icon [icon]="faRoad" style="color: black;"></fa-icon>
                {{ activity.distance  | distancePipe }} mi
                
              </p>  
              
            </div> 
            <!-- TEMPS -->
            <div class="col-md-4">
              <p class="card-text">
                <fa-icon [icon]="faClock" class="fa-1x" style="color: black;"></fa-icon>
                {{ activity.duration | timePipe }} min 
              </p>    
            </div> 
            <!-- DATE -->
            <div class="col-md-4">
              <p class="card-text">
                <small class="text-muted text-right">{{ activity.dateTime | date:"dd/MM/yyyy" }}</small>
                <button mat-button  *ngIf="activity.displayRemove" (click)="deleteRun(activity._id, activity )" color="warn">Delete run</button>
              </p>  
            </div> 

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-spinner *ngIf="showMoreActivitysLoading"></mat-spinner>
<button mat-raised-button color="primary" *ngIf="showMoreActivitys && !showMoreActivitysLoading" (click)="loadMoreActivitys()">Check for more activitys</button>

